import React, { useState, useEffect, useRef } from 'react'
import classnames from 'classnames'
import ValueCard, { ICarReview } from './value-card'
import getUrl from 'lib/url'
import getCityName from 'lib/get-city-name'
import fetch from 'lib/decorated-fetch'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { logger } from 'lib/slardar-utils'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import {
  computedResponsive,
  useResponsive,
} from 'Components/hooks/use-responsive'
import SwiperButton from 'Components/swiper-button'
// import TryCatchRender from 'Components/try-catch-render'
import ResponsiveSwiper, {
  ResponsiveConfig,
} from 'Components/new/responsive-swiper'
import propsFilter, { IFilterConfig } from 'lib/props-filter'
import { decodeUri } from 'Components/view-image/decode'
import style from './index.module.scss'

const filterConfig: IFilterConfig = {
  type: 'array',
  props: {
    is_new_energy: '',
    series_type: '',
    score: '',
    author_info: (value) => ({
      user_id: value?.user_id,
      user_name: value?.user_name,
      avatar_url:
        value?.avatar_uri || decodeUri(value?.avatar_url) || value?.avatar_url,
    }),
    series_name: '',
    series_id: '',
    content: (value) => value?.substr(0, 80),
    cover_url: (value) => decodeUri(value) || value,
    car_id: '',
    car_name: '',
    rank: '',
    item_rank: '',
    total_review_count: '',
    year: '',
    series_review: {
      type: 'object',
      props: {
        comfort_score: '',
        appearance_score: '',
        configuration_score: '',
        control_score: '',
        power_score: '',
        space_score: '',
        interiors_score: '',
        score: '',
      },
    },
    group_id_str: '',
  },
}

export const getDcarScoreData = async (req?: any) => {
  const params = {
    // city_name: getCityName(asPath, req),
  }
  const json = await fetch(
    getUrl(
      `/motor/pc/content/pc_car_reviews/v2?${serializeObject(params)}`,
      'motor.pc_content.api'
    ),
    {
      req,
    }
  ).catch((error) => {
    logger.warn(`[fetch] dCarScore error. err=${error.message}`)
    return []
  })

  function formatList(list: any[]) {
    let data = list || []
    if (!Array.isArray(data)) {
      data = []
    }
    try {
      return propsFilter(data, filterConfig)
    } catch (e) {
      if (req?.metrics) {
        req.metrics.emitCounter('props.filter.fail', 1, undefined, {
          url: '/motor/pc/content/pc_car_reviews/v2',
        })
      }
      return data
    }
  }
  const tabList = json?.data?.car_review_v2_list || []
  tabList.forEach((item: any) => {
    item.car_review_list = formatList(item.car_review_list)
  })
  return tabList
}

// is_new_energy?: boolean;  // 是否是新能源 前端处理
// series_type?: number;  //车系类型 0 轿车 1 suv 2 mpv
// 数据切换：切换不固定次数，确保不丢弃数据
// - 5列（1920）：5列*6切 =30个内容（最大值）;轿车-2、suv-1、新能源-1、mpv-1
// - 4列（1680/1440/1280/1024）：4列*8切 ， 满足30（最大值）; 轿车-1、suv-1、新能源-1、mpv-1

// 通过一个配置遍历获取
interface IConfig {
  [key: string]: {
    page: number
    types: number[]
  }
}
const MAX_LENGTH = 30 //
const pageConfig: IConfig = {
  5: {
    page: 6,
    types: [2, 1, 1, 1], // 轿车、suv、新能源、mvp
  },
  4: {
    page: 8,
    types: [1, 1, 1, 1],
  },
}

const defaultNum = 4

const cols: ResponsiveConfig = {
  sm: 4,
  md: 4,
  lg: 4,
  xl: 4,
  '2xl': 5,
}

const rows: ResponsiveConfig = {
  sm: 1,
  md: 1,
  lg: 1,
  xl: 1,
  '2xl': 1,
}

export interface IDcarScoreTab {
  tab_name: string
  tab_type: string
  car_review_list: ICarReview[]
}

export default function DongCheFen({
  dcarScoreData,
}: {
  dcarScoreData?: IDcarScoreTab[]
}) {
  // (1) 基本数据
  const responsive = useResponsive()
  const [tabList, setTabList] = useState<IDcarScoreTab[]>([])
  const [curTab, setCurTab] = useState({} as IDcarScoreTab)
  const [swiperCarList, setSwiperCarList] = useState<ICarReview[]>([])
  const timerRef = useRef<number>()
  const [prevEl, setPrevEl] = useState<HTMLElement | null>(null)
  const [nextEl, setNextEl] = useState<HTMLElement | null>(null)

  useEffect(() => {
    getDcarScoreData().then((res) => {
      setTabList(res)
      setCurTab(res[0])
    })
  }, [])

  /** (2) 按规则计算得到热门懂车分下的车辆列表 */
  const computedCarList = (num: number, carList: ICarReview[]) => {
    const typeList: ICarReview[][] = [[], [], []]
    const newEnergy: ICarReview[] = []
    carList.forEach((item) => {
      if (item.is_new_energy) {
        newEnergy.push(item)
      } else {
        if (typeList[item.series_type]) {
          typeList[item.series_type].push(item)
        }
      }
    })
    // 新能源顺序的第三个
    typeList.splice(2, 0, newEnergy)
    let result: ICarReview[] = []
    let isContinue = true
    let times = 0
    const currentPageConfig = pageConfig[num]
    while (isContinue) {
      let isAdd = true // 必须遍历添加完整的一组数组
      let tmp: ICarReview[] = []
      currentPageConfig.types.forEach((value, index) => {
        if (typeList[index].length < value) {
          isAdd = false
          return
        }
        tmp = tmp.concat(typeList[index].splice(0, value))
      })
      if (isAdd) {
        result = result.concat(tmp)
        times++
      } else {
        isContinue = false
      }
      if (result.length >= MAX_LENGTH) {
        isContinue = false
      }
    }
    return { result, times }
  }

  // (3) 响应式初始化
  useEffect(() => {
    if (!curTab) {
      return
    }
    let num = defaultNum
    if (responsive['2xl']) {
      num = defaultNum + 1
    }
    // 热门则按规则排列数据
    if (curTab.tab_type === 'hot') {
      const { result } = computedCarList(num, curTab.car_review_list || [])
      setSwiperCarList(result)
      return
    }
    const result = (curTab.car_review_list || []).slice(
      0,
      pageConfig[num].page * num
    )
    setSwiperCarList(result)
  }, [responsive?.['2xl'], curTab])

  // (4) 返回 react 元素
  return (
    <React.Fragment>
      <div
        className={style['top-bar']}
        data-log-view-config={JSON.stringify({
          repeated: true,
        })}
        data-log-view={JSON.stringify({
          event: 'show_event',
          params: {
            page_id: 'page_main_new',
            event_id: 'common_conponent_module',
            module_id: 'dscore_module',
          },
        })}
      >
        <div className="tw-flex tw-items-center">
          <span
            className={`${style['title']} title`}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'dscore_module_title',
                module_id: 'dscore_module',
              })
            }}
          />
          <ul className="tw-flex tw-text-14 tw-leading-22 tw-ml-12">
            {tabList.map((item) => {
              return (
                <li
                  className={classnames(
                    'tw-relative tw-w-64 tw-h-22 tw-mr-6 tw-text-center tw-cursor-pointer',
                    {
                      [style['tab-active']]: curTab.tab_name === item.tab_name,
                    }
                  )}
                  key={item.tab_name}
                  onMouseEnter={() => {
                    timerRef.current = window.setTimeout(() => {
                      setCurTab(item)
                      sendTeaCommEvent('hover_event', {
                        page_id: 'page_main_new',
                        module_id: 'dscore_module',
                        event_id: 'car_category_tab_hover',
                        button_name: item.tab_name,
                      })
                    }, 200)
                  }}
                  onMouseLeave={() => {
                    if (timerRef.current) {
                      window.clearTimeout(timerRef.current)
                    }
                  }}
                >
                  {item.tab_name}
                </li>
              )
            })}
          </ul>
        </div>
        <SwiperButton
          ref={setPrevEl}
          type="prev"
          buttonStyle={{
            justifySelf: 'flex-end',
            marginLeft: 'auto',
          }}
          className="swiper-button-disabled"
        />
        <SwiperButton
          ref={setNextEl}
          type="next"
          buttonStyle={{
            justifySelf: 'flex-end',
          }}
        />
      </div>
      <ResponsiveSwiper
        gap={12}
        slideCount={swiperCarList.length || 5}
        cols={cols}
        rows={rows}
        slideClass="tw-w-2.5 2xl:tw-w-2/10"
        navigation={{
          prevEl,
          nextEl,
        }}
        onSlideChange={() => {
          sendTeaCommEvent('clk_event', {
            event_id: 'dscore_module_change',
            module_id: 'dscore_module',
          })
        }}
        key={curTab.tab_name}
        className="tw-mt-12 tw-bb-15"
      >
        {({ index, activeIndex }) => {
          return swiperCarList.length ? (
            <ValueCard
              {...swiperCarList[index]}
              rank={activeIndex}
              item_rank={index % (cols[computedResponsive()] * 2)}
            />
          ) : (
            <div
              style={{ height: 302 }}
              className={classnames({
                'g-load-img-wrap': true,
                'tw-hidden': index >= 4,
                '2xl:tw-block': index >= 4,
              })}
            />
          )
        }}
      </ResponsiveSwiper>
      <style jsx>
        {`
          .title {
            background-image: url(${require('static/dcar-score-black.png')});
          }
        `}
      </style>
    </React.Fragment>
  )
}
